export const octoberAbbreviatedLowercase = "CA8YA";
export default {octoberAbbreviatedLowercase};